export default "__VITE_ASSET__LC2haQ2F__"